import { CommonModule } from '@angular/common';
import { Component, EventEmitter, input, Input, Output } from '@angular/core';
import { Spacing } from '@app/shared/types';

export enum ButtonType {
  PRIMARY = 'primary',
  SECONDARY = 'secondary', // Used as a secondary button.
  GHOST = 'ghost', // Used as a secondary button to not call for attention.
  DESTRUCTIVE = 'destructive', // Used as a secondary to show it's a destuctive action (red colored).
  UTILITY = 'utility',
}

export enum NativeButtonType {
  BUTTON = 'button',
  SUBMIT = 'submit',
  RESET = 'reset',
}

export enum ButtonSize {
  X_SMALL = 'xsmall',
  SMALL = 'small',
  LARGE = 'large',
}

export enum ButtonIcon {
  NONE = 'none',
  EMAIL = 'email',
  DOCUMENT = 'document',
  PLUS = 'plus',
  CHECK = 'check',
  X = 'x',
}

export enum ButtonShape {
  DEFAULT = 'default',
  CIRCLE = 'circle',
}

@Component({
  standalone: true,
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.css'],
  imports: [CommonModule],
})
export class ButtonComponent {
  @Input() shape = ButtonShape.DEFAULT;
  @Input() type!: ButtonType;
  @Input() nativeType = NativeButtonType.BUTTON;
  @Input() size = ButtonSize.SMALL;
  @Input() buttonIcon = ButtonIcon.NONE;
  error = input(false);
  @Input() disabled = false;
  @Input() testId!: string;
  @Input() spacingBottom = Spacing.MEDIUM;
  @Output() handleClick = new EventEmitter<void>();
  ButtonIcon = ButtonIcon;

  onClick() {
    this.handleClick.emit();
  }
}
